export default "__VITE_ASSET__Bj_O3VRD__"